import React, { useEffect, useRef, useState } from 'react';

export const useAppToast = () => {
  const [toast, setToast] = useState(null);
  const toastTimer = useRef(null);

  useEffect(() => {
    return () => {
      if (toastTimer.current) {
        clearTimeout(toastTimer.current);
      }
    };
  }, []);

  const showToast = (message, type = 'success') => {
    if (toastTimer.current) {
      clearTimeout(toastTimer.current);
    }

    setToast({ message, type });
    toastTimer.current = setTimeout(() => {
      setToast(null);
      toastTimer.current = null;
    }, 3500);
  };

  return { toast, showToast };
};

const AppToast = ({ toast }) => {
  if (!toast) return null;

  return (
    <div
      className={`fixed left-1/2 top-6 z-[100] w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 rounded-lg px-5 py-4 text-center font-heebo text-sm shadow-lg ${
        toast.type === 'error'
          ? 'bg-red-600 text-white'
          : 'bg-[#273a84] text-white'
      }`}
      role="status"
    >
      {toast.message}
    </div>
  );
};

export default AppToast;
